import { useMutation, useQueryClient } from '@tanstack/react-query';
import { journalsService } from '../services/journals.service';
import type { JournalEntryDetail, JournalEntryFeedback } from '../types/api.types';
import toast from 'react-hot-toast';

export const useRequestReview = (journalId: string, entryId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => journalsService.requestReview(journalId, entryId),
    onSuccess: (feedback: JournalEntryFeedback) => {
      // Update the cached entry detail directly so the feedback appears immediately
      queryClient.setQueryData<JournalEntryDetail>(
        ['journals', journalId, 'entries', entryId],
        (old) => old ? { ...old, latestFeedback: feedback } : old,
      );
      toast.success('Review complete!');
    },
    onError: (error: any) => {
      if (error?.response?.status === 402) {
        toast.error('AI review requires a Pro subscription');
      } else if (error?.response?.status === 429) {
        toast.error('Please wait a moment before requesting another review');
      } else {
        toast.error('Review failed. Please try again.');
      }
    },
  });
};
